import React, { PureComponent } from "react";

//import Switch from "Common/Switch/Switch";
import Page from "./Page";

import styles from "./Pages.local.scss";
import classnames from "classnames";
import _ from "i18n";

export default class PagesComponent extends PureComponent {
  render() {
    const { fetching, pages, order, indexSetting } = this.props;
    if (fetching) {
      return (
        <ul className={classnames(styles.pages, "grid-x")}>
          <li className="cell small-4">
            <span className={styles.fetching} />
          </li>
          <li className="cell small-4">
            <span className={styles.fetching} />
          </li>
          <li className="cell small-4">
            <span className={styles.fetching} />
          </li>
        </ul>
      );
    }

    if (!pages || pages.length === 0) {
      return null;
    }

    return (
      <ul className={classnames(styles.pages, "grid-x")}>
        {pages.map(page => (
          <li key={`page-${page.id}`} className="cell small-4">
            <Page page={page} order={order} indexSetting={indexSetting} />
          </li>
        ))}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Pages/PagesComponent.js